/*
  Footer: mobil sütun akordiyonları + ülke/para birimi seçici. Yukarı çık düğmesi. Vanilla JS.
*/

if (!customElements.get('alv-footer')) {
  class AlvFooter extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-alv-footer-toggle]').forEach((btn) => {
        const body = document.getElementById(btn.getAttribute('aria-controls'));
        if (!body) return;
        btn.addEventListener('click', () => {
          const open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!open));
          body.hidden = open;
        });
      });
      const country = this.querySelector('[data-alv-country]');
      if (country) country.addEventListener('change', () => country.form.submit());
    }
  }

  customElements.define('alv-footer', AlvFooter);
}

if (!customElements.get('alv-to-top')) {
  class AlvToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.threshold = 600;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
      this.button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: this.reduced.matches ? 'auto' : 'smooth' });
      });
    }

    onScroll() {
      const visible = window.scrollY > this.threshold;
      if (visible === this.visible) return;
      this.visible = visible;
      this.classList.toggle('is-visible', visible);
      // Görünmezken klavye odağından da çıkar
      this.button.tabIndex = visible ? 0 : -1;
    }
  }

  customElements.define('alv-to-top', AlvToTop);
}
